/* eslint-disable indent */
import styled from 'styled-components';

import { COLORS } from 'theme';

export const StepperContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing.m4};
`;

export const StepItem = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.s1};
  align-items: center;
  padding: ${({ theme }) => `${theme.spacing.s1} 10px ${theme.spacing.s1} 6px`};
  border-radius: ${({ theme }) => theme.spacing.m1};
  border: 1px solid
    ${({ $isHighlighted, $disabled }) =>
      $isHighlighted && !$disabled
        ? `${COLORS.kinetikBlue}`
        : `${COLORS.black06}`};
  background: ${({ $isHighlighted, $disabled }) => {
    if ($disabled) {
      return `${COLORS.black06}`;
    }
    if ($isHighlighted) {
      return `${COLORS.kinetikBlue}`;
    }
    return COLORS.white;
  }};
  color: ${({ $isFilled, $isHighlighted, $disabled }) => {
    if ($disabled) {
      return `${COLORS.black30}`;
    }
    if ($isFilled) {
      return `${COLORS.kinetikBlack}`;
    }
    if ($isHighlighted) {
      return `${COLORS.white}`;
    }
    return `${COLORS.black50}`;
  }};
  cursor: ${({ $isFilled, $disabled }) =>
    $isFilled && !$disabled ? 'pointer' : 'auto'};
`;

export const StepLabel = styled.span`
  font-size: ${({ theme }) => theme.fontSize.body3};
  font-weight: ${({ theme }) => theme.fontWeight?.medium};
  line-height: ${({ theme }) => theme.spacing.s3};
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: ${({ theme }) => theme.spacing.s4};
  height: ${({ theme }) => theme.spacing.s4};

  svg {
    width: ${({ theme }) => theme.spacing.s4};
    height: ${({ theme }) => theme.spacing.s4};
  }

  svg path {
    fill: ${({ $isHighlighted, $disabled }) =>
      $isHighlighted && !$disabled ? `${COLORS.kinetikBlue}` : 'transparent'};
    stroke: ${({ $isHighlighted, $disabled }) => {
      if ($disabled) {
        return `${COLORS.black20}`;
      }
      if ($isHighlighted) {
        return `${COLORS.white}`;
      }
      return `${COLORS.black10}`;
    }};
    stroke-width: 2;
  }
`;

export const CheckIconContainer = styled.div`
  display: flex;
  svg {
    width: ${({ theme }) => theme.spacing.s4};
    height: ${({ theme }) => theme.spacing.s4};
  }
  svg path {
    fill: ${COLORS.kinetikBlue};
  }
`;

export const ChevronContainer = styled.div`
  display: flex;
  align-items: center;
  svg path {
    fill: ${COLORS.black30};
  }
`;
